module.exports = __webpack_public_path__ + "static/media/2-circle-onhold.62a4dd60.svg";